// Module
var code = `<condition ng-if="\$ctrl.propertyDefinition.type === \$ctrl.type"
           conditions="\$ctrl.conditions"
           property="\$ctrl.propertyDefinition.property">
  <div class="condition-container">
    {{\$ctrl.propertyDefinition.label}}

    <multiselect items="\$ctrl.dictionaryEntries"
                 ng-model="\$ctrl.model.param"
                 label-property="'label'"
                 value-property="'value'"
                 select-all-option="true"
                 ng-disabled="true">
    </multiselect>
  </div>
</condition>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/conditions/substituted-value-condition.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;